import { formOptions } from '@tanstack/react-form';
import { z } from 'zod';

export const twitterQuerySetSchema = z
  .object({
    hashtags: z.array(z.string()),
    keywords: z.array(z.string()),
    definition: z
      .string()
      .max(500, { message: 'Definition must be 500 characters or less' }),
  })
  .refine((data) => data.hashtags.length > 0 || data.keywords.length > 0, {
    message: 'Either hashtags or keywords is required',
  });

export const twitterSettingFormSchema = z.object({
  query_set: z.array(twitterQuerySetSchema).min(1),
});

export type TwitterSettingFormData = z.infer<typeof twitterSettingFormSchema>;
export type TwitterQuerySetData = z.infer<typeof twitterQuerySetSchema>;

export const twitterSettingFormOptions = formOptions({
  defaultValues: {
    query_set: [{ hashtags: [], keywords: [], definition: '' }],
  } as TwitterSettingFormData,
});
